<script setup lang="ts">
const { opened, contentRef } = await useInvitationPage();
const floatingButtonRef = useTemplateRef("floatingButton");
const { template, coupleName } = storeToRefs(useTemplateStore());

const formattedDate = computed(() => {
  if (!template.value.general.date) {
    return "";
  }

  return new Date(template.value.general.date).toLocaleDateString("id-ID", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
});

watch(
  () => opened.value,
  (val) => {
    if (val && import.meta.client) {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      floatingButtonRef.value?.onToggleMusic();

      setTimeout(() => {
        contentRef.value?.focus();
      }, 500);
    }
  },
);
</script>

<template>
  <div>
    <LazyUiTransitionsInvitationCover>
      <POpeningCard
        v-if="!opened"
        :formatted-date="formattedDate"
        @open="opened = true"
      />
    </LazyUiTransitionsInvitationCover>

    <NuxtLayout
      :opened="opened"
    >
      <LazyUiTransitionsInvitationMain>
        <div
          ref="contentRef"
          tabindex="-1"
          class="ap-006-safe-min-screen bg-primary-950 outline-none lg:grid lg:grid-cols-[minmax(0,1fr)_var(--ap-006-panel-width)]"
        >
          <LazyPLeftShowcase
            v-if="opened"
            :couple-name="coupleName"
            :formatted-date="formattedDate"
            :groom-initial="template.general.initials.groom"
            :bride-initial="template.general.initials.bride"
          />

          <template
            v-if="opened"
          >
            <div class="ap-006-safe-min-screen relative lg:col-start-2 lg:border-x lg:border-white/12 lg:bg-primary-950 lg:shadow-[-24px_0_80px_rgba(0,0,0,0.45)]">
              <LazyPHero
                :opened="opened"
                :formatted-date="formattedDate"
              />
              <LazyVisiblePEvents hydrate-on-visible />
              <LazyVisiblePEventsCountdown hydrate-on-visible />
              <LazyVisiblePLocation hydrate-on-visible />
              <LazyVisiblePGallery hydrate-on-visible />
              <LazyVisiblePRsvp hydrate-on-visible />
              <LazyVisiblePDressCode hydrate-on-visible />
              <LazyVisiblePGift hydrate-on-visible />
              <LazyVisiblePWishes hydrate-on-visible />
              <LazyVisiblePClosing hydrate-on-visible />
            </div>
          </template>

          <!-- Floating Buttons -->
          <div
            v-show="opened"
          >
            <LazyPFloatingButton
              ref="floatingButton"
              :opened="opened"
            />
          </div>
        </div>
      </LazyUiTransitionsInvitationMain>
    </NuxtLayout>
  </div>
</template>
